import {
  EnumBuilder,
  OrAnyStringSchema,
  type ZodSimplify,
} from '@mntn-dev/utility-types'
import { z } from 'zod'

export const [HorizontalSides, HorizontalSidesSchema] = EnumBuilder(
  'left',
  'right'
)
export type HorizontalSide = ZodSimplify<typeof HorizontalSidesSchema>

export const [AutomaticInteractionAreas, AutomaticInteractionAreaSchema] =
  EnumBuilder('portrait', 'landscape', 'all', 'center')
export type AutomaticInteractionArea = ZodSimplify<
  typeof AutomaticInteractionAreaSchema
>

export const [SuggestedGoogleFonts, SuggestedGoogleFontSchema] = EnumBuilder(
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Source Sans Pro',
  'Oswald',
  'Raleway',
  'Merriweather',
  'Nunito',
  'Ubuntu',
  'Playfair Display',
  'Noto Sans',
  'Roboto Condensed',
  'PT Sans',
  'Lora',
  'Dancing Script',
  'Rubik',
  'Titillium Web',
  'Inconsolata',
  'Bebas Neue',
  'Libre Baskerville',
  'Josefin Sans',
  'Fira Sans',
  'Poppins',
  'Arimo'
)
export type SuggestedGoogleFont = ZodSimplify<typeof SuggestedGoogleFontSchema>

export const FontFaceSchema = z.union([
  SuggestedGoogleFontSchema,
  z.literal('inherit'),
  z.literal(false),
  OrAnyStringSchema,
])

export type FontFace = ZodSimplify<typeof FontFaceSchema>

export const [VideoPlaylistStyles, VideoPlaylistStyleSchema] = EnumBuilder(
  'minimal',
  'default'
)
export type VideoPlaylistStyle = ZodSimplify<typeof VideoPlaylistStyleSchema>

export const [VideoPlaylistOrientations, VideoPlaylistOrientationSchema] =
  EnumBuilder('vertical', 'horizontal')
export type VideoPlaylistOrientation = ZodSimplify<
  typeof VideoPlaylistOrientationSchema
>

export const [VideoPlaylistVisibleTotals, VideoPlaylistVisibleTotalSchema] =
  EnumBuilder('1', '2', '3', '4')

export const VideoPlaylistTotalSchema = z.union([
  VideoPlaylistVisibleTotalSchema,
  OrAnyStringSchema,
])

export type VideoPlaylistTotal = ZodSimplify<typeof VideoPlaylistTotalSchema>

export const [VideoPlayerAutoplayModes, VideoPlayerAutoplayModeSchema] =
  EnumBuilder('never', 'always', 'on-scroll')
export type VideoPlayerAutoplayMode = ZodSimplify<
  typeof VideoPlayerAutoplayModeSchema
>

export const [VideoPlayerPreloadOptions, VideoPlayerPreloadOptionSchema] =
  EnumBuilder('auto', 'metadata', 'none')
export type VideoPlayerPreloadOption = ZodSimplify<
  typeof VideoPlayerPreloadOptionSchema
>

export const [SuggestedVideoSourceTypes, SuggestedVideoSourceTypeSchema] =
  EnumBuilder(
    'audio',
    'auto',
    'dash',
    'f_auto',
    'flv',
    'hls',
    'm3u8',
    'mp4',
    'mp4/h264',
    'mp4/h264/aac',
    'mp4/h265',
    'ogg',
    'progressive',
    'ts',
    'webm',
    'webm/vp8',
    'webm/vp9'
  )

export const VideoSourceTypeSchema = z.union([
  SuggestedVideoSourceTypeSchema,
  OrAnyStringSchema,
])

export type VideoSourceType = ZodSimplify<typeof VideoSourceTypeSchema>

export const [TextTrackThemes, TextTrackThemeSchema] = EnumBuilder(
  'default',
  'videojs-default',
  'yellow-outlined',
  'player-colors',
  '3d'
)

export type TextTrackTheme = ZodSimplify<typeof TextTrackThemeSchema>
